import { initializePaddle, Paddle, PaddleEventData } from "@paddle/paddle-js";
import { CONFIG } from "~/config";
import { IUserInfo } from "~/state/user/interfaces";
import { getUserEmail } from "~/util/user";
import { payComplete } from "~/util/providers/premium";
import { isDarkMode } from "~/util/detect";

//const CONTAINER_CLASS = "paddle-pay-container";

class PaddleWrapperClass {
	#paddle: Paddle;

	#purchaseOrigin: string;

	constructor() {
		this.#paddle = null;
		this.#purchaseOrigin = "";
	}

	async openPaddle(priceId: string, user: IUserInfo, purchaseOrigin = "") {
		if (!this.#paddle) {
			await this.initialize();
		}

		this.#purchaseOrigin = purchaseOrigin;

		this.#paddle.Spinner.show();

		this.#paddle.Checkout.open({
			customData: {
				// eslint-disable-next-line camelcase
				binding_id: user.premiumData?.profile?.id || "",
			},
			items: [{
				quantity: 1,
				priceId,
			}],
			customer: {
				address: {
					countryCode: user.premiumData?.profile?.country || "",
					...user.premiumData?.profile?.region
						? { region: user.premiumData?.profile?.region }
						: {},
					...user.premiumData?.profile?.zip
						? { postalCode: user.premiumData?.profile?.zip }
						: {},
				},
				email: getUserEmail(),
			},
			/*settings: {
				frameTarget: CONTAINER_CLASS,
			},*/
		});
	}

	async initialize(callback?: (event: PaddleEventData) => void) {
		if (!this.#paddle) {
			this.#paddle = await initializePaddle({
				environment: CONFIG.paddleEnvironment,
				token: CONFIG.paddleToken,
				checkout: {
					settings: {
						allowLogout: false,
						showAddDiscounts: false,
						showAddTaxId: false,
						theme: isDarkMode() ? "dark" : "light",
						locale: CONFIG.defaultLang,
						displayMode: "overlay",
						variant: "one-page",
					},
				},
			});
		}

		if (callback) {
			// eslint-disable-next-line new-cap
			this.#paddle.Update({
				eventCallback: async (event: PaddleEventData) => {
					if (event.name === "checkout.completed") {
						await payComplete(event.data.transaction_id, "paddle");

						await Mapy.getComponent("login").relogin();

						Mapy.getComponent("logger").log("premiumPurchase_success", {
							purchaseOrigin: this.#purchaseOrigin,
						});

						Mapy.getComponent("premiumStatus").activate();
					}

					callback && callback(event);
				},
			});
		}
	}
}

const PaddleWrapper = new PaddleWrapperClass();

export default PaddleWrapper;
